import { jsx as _jsx } from "react/jsx-runtime";
import styles from './style.module.less';
import { buildDisplayChanges } from '../history-utils';
import ChangeItem from './ChangeItem';
const ChangeList = ({ changes }) => {
    const displayChanges = changes === null ? null
        : buildDisplayChanges(changes);
    if (displayChanges === null || displayChanges.length === 0) {
        return (_jsx("ul", { className: styles.changeList, children: _jsx(ChangeItem, { change: null }) }));
    }
    return (_jsx("ul", { className: styles.changeList, children: displayChanges.map((change) => (_jsx(ChangeItem, { change: change }, change.key))) }));
};
export default ChangeList;
